import Stripe from "stripe";
import { Machine, assign } from "xstate";
import { SignupFormData } from "./types";

interface IContext {
  memberDetails: SignupFormData;
  priceLookUpKey: string;
  invoice: Stripe.Invoice;
}

interface IState {
  states: {
    memberDetails: {};
    plans: {};
    payment: {};
    success: {};
  };
}

export const signupMachine = Machine<IContext, IState>(
  {
    id: "signupMachine",
    initial: "memberDetails",
    states: {
      memberDetails: {
        id: "memberDetails",
        on: {
          PROCEED: {
            actions: "SAVE_MEMBER_DETAILS",
            target: "plans",
          },
        },
      },
      plans: {
        id: "plans",
        on: {
          PROCEED: {
            target: "payment",
          },
          UPDATE: {
            actions: "SAVE_PRICE_LOOK_UP_KEY",
          },
          BACK: "memberDetails",
        },
      },
      payment: {
        on: {
          BACK: "plans",
          PROCEED: {
            target: "success",
            actions: "SAVE_INVOICE"
          }
        },
      },
      success: {
        id: "success",
      },
    },
  },
  {
    actions: {
      SAVE_MEMBER_DETAILS: assign({
        memberDetails: (c, e) => e.values,
      }),
      SAVE_PRICE_LOOK_UP_KEY: assign({
        priceLookUpKey: (c, e) => e.values,
      }),
      SAVE_INVOICE: assign({
        invoice: (c, e) => e.values
      }),
      log: (c, e) => console.log(e),
    },
  }
);
